import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ScaleIcon, UsersIcon, TrendingDownIcon, DatabaseIcon, ShieldAlertIcon, ServerCrashIcon, AlertTriangleIcon } from 'lucide-react';
export function AssessmentResultsPage() {
  const location = useLocation();
  const answers = location.state?.answers || {};
  return <div className="w-full min-h-screen bg-[#f8f9fa] flex flex-col font-sans" data-id="element-570" data-mp="2n6ybmf6dmbxg">
      {/* Header */}
      <header className="w-full bg-[#1a0647] px-6 py-4" data-id="element-571" data-mp="2r6qkkszomk3c">
        <div className="max-w-6xl mx-auto flex items-center" data-id="element-572" data-mp="2w5a8gyxu65yc">
          <Link to="/" className="flex-shrink-0" data-id="element-573" data-mp="2w7wgt0sjwphm">
            <img src="https://cdn.magicpatterns.com/uploads/ddFjEWvaDfXw4mBqdFC5Gd/Caveo_Logotype_Horizontal_240x50_White_PNG.png" alt="Caveo" className="h-5" data-id="element-574" data-mp="3167pv9b0uvys" />
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 max-w-6xl mx-auto w-full px-6 py-12 space-y-12" data-id="element-575" data-mp="1bpge3xfe28jd">
        {/* Top Section: Score & Alerts */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-576" data-mp="3jtyn4filzx6k">
          {/* Score Gauge Card */}
          <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8 flex flex-col items-center justify-center" data-id="element-577" data-mp="3f1ouusu0ul14">
            <div className="relative w-64 h-40 flex flex-col items-center justify-end overflow-hidden mb-4" data-id="element-578" data-mp="3a1ar3mzgdx8w">
              {/* SVG Gauge */}
              <svg viewBox="0 0 200 110" className="absolute top-0 left-0 w-full h-full" data-id="element-579" data-mp="6mwyr92lj8eg">
                {/* Background Arc */}
                <path d="M 20 100 A 80 80 0 0 1 180 100" fill="none" stroke="#f0f0f0" strokeWidth="16" strokeLinecap="round" data-id="element-580" data-mp="3stlgqf53jyp2" />
                {/* Foreground Arc (Green) - approx 80% filled */}
                <path d="M 20 100 A 80 80 0 0 1 150 40" fill="none" stroke="#98d077" strokeWidth="16" strokeLinecap="round" data-id="element-581" data-mp="2ddcwmk79rw24" />
                {/* Indicator Circle */}
                <circle cx="150" cy="40" r="6" fill="white" stroke="#98d077" strokeWidth="4" data-id="element-582" data-mp="2jradt7pqb0cu" />
                {/* Segment Gaps (White lines to break the arc) */}
                <path d="M 60 20 L 70 35" stroke="white" strokeWidth="4" fill="none" transform="rotate(-30 100 100)" data-id="element-583" data-mp="1w2her2dt8ce0" />
                <path d="M 130 20 L 140 35" stroke="white" strokeWidth="4" fill="none" transform="rotate(30 100 100)" data-id="element-584" data-mp="1m3rytf5h520e" />
              </svg>

              {/* Score Text */}
              <div className="text-center z-10 mt-12" data-id="element-585" data-mp="1h5qhaynp5ar1">
                <div className="text-6xl font-bold text-[#2d2a54] leading-none mb-1" data-id="element-586" data-mp="yhfxwrihtj0y">
                  684
                </div>
                <div className="text-3xl font-bold text-[#98d077]" data-id="element-587" data-mp="tkphu46ounfj">B</div>
              </div>
            </div>

            <p className="text-[#6b7280] text-sm font-medium text-center" data-id="element-588" data-mp="17k77smvq06qh">
              The industry average score for a secure
              <br data-id="element-589" data-mp="1hgtu7g3p35um" />
              family is <span className="text-[#98d077]" data-id="element-590" data-mp="1hg1x20ug9028">685</span>
            </p>
          </div>

          {/* Security Alerts Card */}
          <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8 flex flex-col items-center justify-center" data-id="element-591" data-mp="1chh5sqx6dqpx">
            <div className="flex items-center justify-center gap-3 mb-2" data-id="element-592" data-mp="1qb8anlzyomfb">
              <span className="text-6xl font-bold text-[#2d2a54]" data-id="element-593" data-mp="1m8ll5rqrjdla">21</span>
              <div className="bg-red-50 p-2 rounded-full" data-id="element-594" data-mp="208cwfkpwafvl">
                <AlertTriangleIcon className="w-8 h-8 text-[#f28b82]" fill="#f28b82" stroke="white" data-id="element-595" data-mp="1v8qi17ybytl7" />
              </div>
            </div>
            <h2 className="text-xl font-bold text-[#7a809b] mb-8" data-id="element-596" data-mp="2jbogjkmuyx02">
              Security Alerts Detected
            </h2>

            <div className="grid grid-cols-3 gap-4 w-full" data-id="element-597" data-mp="2o3y3crsofgy4">
              {/* High Risk */}
              <div className="bg-[#fafafa] rounded-2xl p-4 flex flex-col items-center justify-center border border-gray-100" data-id="element-598" data-mp="2t0y911lm6hop">
                <span className="text-4xl font-bold text-[#f28b82] mb-1" data-id="element-599" data-mp="1wdbjzoqve1la">
                  4
                </span>
                <span className="text-sm font-bold text-[#7a809b]" data-id="element-600" data-mp="20fewmgp9zc85">
                  High Risk
                </span>
              </div>
              {/* Medium Risk */}
              <div className="bg-[#fafafa] rounded-2xl p-4 flex flex-col items-center justify-center border border-gray-100" data-id="element-601" data-mp="2acb90xiaoihz">
                <span className="text-4xl font-bold text-[#fbbc04] mb-1" data-id="element-602" data-mp="3gtoin461oovt">
                  0
                </span>
                <span className="text-sm font-bold text-[#7a809b]" data-id="element-603" data-mp="1a3bpt7f6w42m">
                  Medium Risk
                </span>
              </div>
              {/* Low Risk */}
              <div className="bg-[#fafafa] rounded-2xl p-4 flex flex-col items-center justify-center border border-gray-100" data-id="element-604" data-mp="1550f6uh2lpjc">
                <span className="text-4xl font-bold text-[#62b073] mb-1" data-id="element-605" data-mp="vef8skv5ngpv">
                  17
                </span>
                <span className="text-sm font-bold text-[#7a809b]" data-id="element-606" data-mp="rdd9y555h6of">
                  Low Risk
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section: Attack Likelihood */}
        <div data-id="element-607" data-mp="hffofpeodnzi">
          <h2 className="text-3xl font-bold text-[#2d2a54] text-center mb-8" data-id="element-608" data-mp="hewd4rjj5xug">
            Attack Likelihood
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-609" data-mp="chxim7vyfovq">
            {/* Legal Consequences */}
            <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8 flex flex-col items-center text-center" data-id="element-610" data-mp="26t2lvb34pzaj">
              <h3 className="text-lg font-bold text-[#2d2a54] mb-6" data-id="element-611" data-mp="53mycqc6qe1f">
                Legal Consequences
              </h3>
              <div className="w-32 h-32 bg-blue-50 rounded-full flex items-center justify-center mb-8" data-id="element-612" data-mp="9wg4ninaxufm">
                <ScaleIcon className="w-16 h-16 text-blue-400" data-id="element-613" data-mp="3r9jv9fipsp00" />
              </div>
              {/* Progress Bar - High (Red) */}
              <div className="w-full flex items-center gap-1 mb-3 relative" data-id="element-614" data-mp="nv60kuydxo2e">
                <div className="h-2.5 flex-1 bg-[#f28b82] rounded-l-full" data-id="element-615" data-mp="nt3daioma91d"></div>
                <div className="h-2.5 flex-1 bg-[#f28b82]" data-id="element-616" data-mp="st7ukaxcn7sn"></div>
                <div className="h-2.5 flex-1 bg-[#f28b82] rounded-r-full relative" data-id="element-617" data-mp="euztbqta5kbo">
                  <div className="absolute right-0 top-1/2 -translate-y-1/2 w-4 h-4 bg-white border-4 border-[#f28b82] rounded-full translate-x-1/2" data-id="element-618" data-mp="iva5xmbkv8zi"></div>
                </div>
              </div>
              <span className="text-sm font-bold text-[#f28b82]" data-id="element-619" data-mp="33mk3mrp8gpa8">
                High Likelihood
              </span>
            </div>

            {/* Reputation Damage */}
            <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8 flex flex-col items-center text-center" data-id="element-620" data-mp="2w4cjq7yhpfmf">
              <h3 className="text-lg font-bold text-[#2d2a54] mb-6" data-id="element-621" data-mp="3618t0fw7q5s1">
                Reputation Damage
              </h3>
              <div className="w-32 h-32 bg-indigo-50 rounded-full flex items-center justify-center mb-8" data-id="element-622" data-mp="312npo7lnz5zd">
                <UsersIcon className="w-16 h-16 text-indigo-400" data-id="element-623" data-mp="2dcthw4g7c7lz" />
              </div>
              {/* Progress Bar - High (Red) */}
              <div className="w-full flex items-center gap-1 mb-3 relative" data-id="element-624" data-mp="28b42kcly57s3">
                <div className="h-2.5 flex-1 bg-[#f28b82] rounded-l-full" data-id="element-625" data-mp="2n35yxmot5ind"></div>
                <div className="h-2.5 flex-1 bg-[#f28b82]" data-id="element-626" data-mp="2iacukzx94cbt"></div>
                <div className="h-2.5 flex-1 bg-[#f28b82] rounded-r-full relative" data-id="element-627" data-mp="1ulabroqvsdfq">
                  <div className="absolute right-0 top-1/2 -translate-y-1/2 w-4 h-4 bg-white border-4 border-[#f28b82] rounded-full translate-x-1/2" data-id="element-628" data-mp="1pmgy9wblgmfk"></div>
                </div>
              </div>
              <span className="text-sm font-bold text-[#f28b82]" data-id="element-629" data-mp="1927jeexvulfv">
                High Likelihood
              </span>
            </div>

            {/* Financial Loss */}
            <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8 flex flex-col items-center text-center" data-id="element-630" data-mp="1e00mv07sx1cg">
              <h3 className="text-lg font-bold text-[#2d2a54] mb-6" data-id="element-631" data-mp="1n20701e44ljm">
                Financial Loss
              </h3>
              <div className="w-32 h-32 bg-emerald-50 rounded-full flex items-center justify-center mb-8" data-id="element-632" data-mp="1s0jsy1sphxbz">
                <TrendingDownIcon className="w-16 h-16 text-emerald-400" data-id="element-633" data-mp="1wrjph5xwyddy" />
              </div>
              {/* Progress Bar - High (Red) */}
              <div className="w-full flex items-center gap-1 mb-3 relative" data-id="element-634" data-mp="21q3bt7gf5r6u">
                <div className="h-2.5 flex-1 bg-[#f28b82] rounded-l-full" data-id="element-635" data-mp="25tsyfrdj9yp8"></div>
                <div className="h-2.5 flex-1 bg-[#f28b82]" data-id="element-636" data-mp="2aqt7mb5ojhkk"></div>
                <div className="h-2.5 flex-1 bg-[#f28b82] rounded-r-full relative" data-id="element-637" data-mp="3v9ltnj8cek35">
                  <div className="absolute right-0 top-1/2 -translate-y-1/2 w-4 h-4 bg-white border-4 border-[#f28b82] rounded-full translate-x-1/2" data-id="element-638" data-mp="3v7iua8lavelr"></div>
                </div>
              </div>
              <span className="text-sm font-bold text-[#f28b82]" data-id="element-639" data-mp="3mb1h6ztdl6nd">
                High Likelihood
              </span>
            </div>

            {/* Data Breaches */}
            <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8 flex flex-col items-center text-center" data-id="element-640" data-mp="htfi7i1c10ik">
              <h3 className="text-lg font-bold text-[#2d2a54] mb-6" data-id="element-641" data-mp="dv8blg0l1fl3">
                Data Breaches
              </h3>
              <div className="w-32 h-32 bg-cyan-50 rounded-full flex items-center justify-center mb-8" data-id="element-642" data-mp="43c1f6l81z0i">
                <DatabaseIcon className="w-16 h-16 text-cyan-400" data-id="element-643" data-mp="11ipz2zctdri9" />
              </div>
              {/* Progress Bar - Low (Green) */}
              <div className="w-full flex items-center gap-1 mb-3 relative" data-id="element-644" data-mp="wqyed5gcag01">
                <div className="h-2.5 flex-1 bg-[#62b073] rounded-l-full relative" data-id="element-645" data-mp="2bjiuwr306ef9">
                  <div className="absolute right-0 top-1/2 -translate-y-1/2 w-4 h-4 bg-white border-4 border-[#62b073] rounded-full translate-x-1/2 z-10" data-id="element-646" data-mp="26l7jibx27vux"></div>
                </div>
                <div className="h-2.5 flex-1 bg-gray-200" data-id="element-647" data-mp="2kie0c0y83khi"></div>
                <div className="h-2.5 flex-1 bg-gray-200 rounded-r-full" data-id="element-648" data-mp="2gicacp1uofi2"></div>
              </div>
              <span className="text-sm font-bold text-[#62b073]" data-id="element-649" data-mp="2uhlm9cj0wng8">
                Low Likelihood
              </span>
            </div>

            {/* Intellectual Property Theft */}
            <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8 flex flex-col items-center text-center" data-id="element-650" data-mp="347oehaiblxdi">
              <h3 className="text-lg font-bold text-[#2d2a54] mb-6" data-id="element-651" data-mp="2zaetc71ys7vh">
                Intellectual Property Theft
              </h3>
              <div className="w-32 h-32 bg-purple-50 rounded-full flex items-center justify-center mb-8" data-id="element-652" data-mp="38abcjt5l4ej5">
                <ShieldAlertIcon className="w-16 h-16 text-purple-400" data-id="element-653" data-mp="3rwcu82frjals" />
              </div>
              {/* Progress Bar - Low (Green) */}
              <div className="w-full flex items-center gap-1 mb-3 relative" data-id="element-654" data-mp="oh6f2uojv75">
                <div className="h-2.5 flex-1 bg-[#62b073] rounded-l-full relative" data-id="element-655" data-mp="3iw6lsuyx90th">
                  <div className="absolute right-0 top-1/2 -translate-y-1/2 w-4 h-4 bg-white border-4 border-[#62b073] rounded-full translate-x-1/2 z-10" data-id="element-656" data-mp="3mwqki2z58chq"></div>
                </div>
                <div className="h-2.5 flex-1 bg-gray-200" data-id="element-657" data-mp="3dwbu4p7bo77d"></div>
                <div className="h-2.5 flex-1 bg-gray-200 rounded-r-full" data-id="element-658" data-mp="3dxwn4adzni34"></div>
              </div>
              <span className="text-sm font-bold text-[#62b073]" data-id="element-659" data-mp="2z90lav2iz1ay">
                Low Likelihood
              </span>
            </div>

            {/* Operational Disruptions */}
            <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8 flex flex-col items-center text-center" data-id="element-660" data-mp="2q7snsf7u24hx">
              <h3 className="text-lg font-bold text-[#2d2a54] mb-6" data-id="element-661" data-mp="2v514ebdc20h2">
                Operational Disruptions
              </h3>
              <div className="w-32 h-32 bg-orange-50 rounded-full flex items-center justify-center mb-8" data-id="element-662" data-mp="vyvtp5pkgc3v">
                <ServerCrashIcon className="w-16 h-16 text-orange-400" data-id="element-663" data-mp="qzj8sqi99f3x" />
              </div>
              {/* Progress Bar - Low (Green) */}
              <div className="w-full flex items-center gap-1 mb-3 relative" data-id="element-664" data-mp="mzihi5a259fg">
                <div className="h-2.5 flex-1 bg-[#62b073] rounded-l-full relative" data-id="element-665" data-mp="1joq4ziu8lsm0">
                  <div className="absolute right-0 top-1/2 -translate-y-1/2 w-4 h-4 bg-white border-4 border-[#62b073] rounded-full translate-x-1/2 z-10" data-id="element-666" data-mp="1epn2a51qbyh7"></div>
                </div>
                <div className="h-2.5 flex-1 bg-gray-200" data-id="element-667" data-mp="15op5a6ppkr84"></div>
                <div className="h-2.5 flex-1 bg-gray-200 rounded-r-full" data-id="element-668" data-mp="15o6ywh9c0wmh"></div>
              </div>
              <span className="text-sm font-bold text-[#62b073]" data-id="element-669" data-mp="3vflpkc53104b">
                Low Likelihood
              </span>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="flex justify-center pt-8 pb-12" data-id="element-670" data-mp="25xye3j9y5asn">
          <Link to="/pricing" className="bg-[#631bb7] text-white px-10 py-4 rounded-xl font-bold text-lg hover:bg-[#521099] transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-1" data-id="element-671" data-mp="2avzw00vmz42j">
            Get Your Personalized Plan
          </Link>
        </div>
      </main>
    </div>;
}